export default __webpack_public_path__ + "e41af66bd362390b7875c1355aed7374.gif";